<template>
    <div id="nav">
        <div class="block-banner bg-purple text-white" v-if="visible == true">
            <router-link to="/" class="return-home font-light">
                <img src="../assets/home.svg" />  Accueil
            </router-link>
            <h1 class="font-light">{{ title }} </h1>
        </div>
        
        <!--<transition name="fade">-->
            <ul>
                <li v-for="(v, k) in links" :key="k">
                    <router-link :to="{ name: v.path }" v-if="v.path != 'none' ">
                        <span class="picto-container">
                            <img :src="require('../assets/' + v.icon)" class="mx-auto d-block"/>
                        </span>
                            <span class="text-center d-block" v-html="v.title" ></span>
                    </router-link>
                    <a href="javascript:void(0)" v-if="v.path == 'none'" v-on:click="initGallery(v.title)" class="dynamic">
                        <span class="picto-container">
                            <img :src="require('../assets/' + v.icon)" class="mx-auto d-block"/>
                        </span>
                        <span class="text-center d-block">{{ v.title }}</span>
                    </a>
                </li>
            </ul>
        <!--</transition>-->
    </div>
</template>

<style lang="scss" scoped>

#nav {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    height: 341px;
    background-color: #fff;
    z-index: 2;
    @media(min-width: 992px) {
        height: 145px;    
    }
    
    .block-banner {
        z-index: 2;
        height: 100px;
        width: 100%;
        position: absolute;
        bottom: 0;
        top: inherit;
        
        @media (min-width: 992px) {
            top: -100px;
        }
        
        h1, h2 {
            margin: 0;
            padding: 32px 0 0 0;
            font-size: 30px;
            @media (min-width: 992px) {
                padding: 19px 0 0 0;
                font-size: 32px;
            }
        }
        
        .return-home {
            width: 104px;
            @media (min-width: 992px) {
                width: 124px;
            }
            height: 44px;
            line-height: 44px;
            display: block;
            position: absolute;
            top: 28px;
            left: 30px;
            border-radius: 22px;
            border: solid 1px white;
            color: white;
            font-size: 16px;
            img, src {
                margin-right: 10px;
            }
        }
    }
    
    ul {
        position: relative;
        top: -30px;
        z-index: 3;
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center!important;
        li {
            width: 160px;
            height: 145px;
            background-color: #fff;
            color: #42145f;
            border-radius: 3px;
            box-shadow: 0 -20px 20px 0 rgba(22, 22, 22, 0.2);
            margin-left: 11.5px;
            margin-right: 11.5px;
            margin-bottom: 30px;
            display: inline-flex;
            text-align: center;
            
            @media (min-width: 992px) {
                /*width: 124px;*/
                width: 120px;
                height: 145px;
                margin-left: 7.5px;
                margin-right: 7.5px;
                margin-bottom: 0;
            }
            
            a {
                font-weight: bold;
                color: #42145f;
                width: 100%;
                
                &.router-link-exact-active {
                    color: #42145f;
                }
                
                img {
                    padding: 27px 0 19px 0;
                }
                span.picto-container {
                    padding: 0;
                    margin: 0;
                    height: 95px;
                    display: block;
                }
                span {
                    /*padding:  0 10px;*/
                    padding: 0 8px;
                }
            }
        }
    } 
    &.li-lvl2 {
        ul li {
            width: 160px;
            height: 145px;
            @media (min-width: 992px) {
                width: 145px;
                height: 145px;
            }
        }    
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

  
</style>

<script>
// @ is an alias to /src
export default {
  name: 'Nav',
  props: {
    links: Array,
    title: String,
    visible: Boolean
  },
  methods: {
      initGallery: function(name) {
          this.$emit('launch-gallery', name)
      }
  },
  mounted ()  {
  }
}
</script>
